import React from "react";
import { RCCButton, RCCIcon, RCCPopover, RCCTooltip } from "react-common-components";
import CheckPermission from "src/components/CheckPermission";
import List from "src/components/List";
import { useAuth } from "src/context/Auth/context";
import { PermissionEnum } from "src/context/Auth/interface";
import { useTranslation } from "src/context/Translations/context";
import { IMetbs002 } from "../../interface";
import { ISWOTItems } from "./interface";
import { WrapperSwotItems, TitleSwotItem } from "./styles";

const SWOTItem: React.FC<ISWOTItems> = ({
	metbs002,
	refModalitem,
	mee001Id,
	permissions,
	loadData
}) => {

	const { translate } = useTranslation();
	const { administrator, superUser } = useAuth();

	const colDelete = (row: any) => (
		<>
			<CheckPermission minimumPermissionRequired={PermissionEnum.CREATE_UPDATE_DELETE}>
				{(permissions >= 2 || administrator || superUser) && (
					<RCCTooltip
						color="red"
						text={translate("Excluir")}
						position="left"	
					>
						<RCCButton
							icon={{name: "trash", color: "#FFF", size: 12}}
							color="red"
							size="xs"
							layout="isRounded"
							onClick={(e) => {e.stopPropagation();  refModalitem.current?.actionButtonDelete(false, row.mes002Id, row.mes002Titulo, {
								mee001Id
							},  loadData); }}
						/>
					</RCCTooltip>	
				)}
			</CheckPermission>		
		</>
	);

	const customHeaderColScore = (row: any) => (
		<>
			<b>{translate("Pontuação")}</b>
		  <RCCPopover
				position="left"
				header={{title:translate("Pontuação")}}
				body={{text: translate(`A pontuação é dada pela multiplicação dos pontos da importância, da ${row[0].mes002Secao === 2 || row[0].mes002Secao === 3  ? "urgência" : "intensidade"} e da tendência`) }}
			>
				<RCCIcon
					style={{marginLeft: 5}}
					name="infoCircle"
					color="grey"
				/>
			</RCCPopover>
		</>
	);

	const colTitle = (row: any) => (
		<>
			{row.mes002Identificador ? 
				<><b>{row.mes002Identificador}</b>&nbsp; - {row.mes002Titulo}</>
				: row.mes002Titulo}
		</>
	);

	const ListComponent = (dataX: IMetbs002[]) => (
		<List 
			data={dataX} 
			showHeader
			columns={[{
				idColumn: "mes002Titulo",
				nameColumn: translate("Item"),
				justify: "left",
				xs: 12,
				sm: 9,
				cellRenderer: colTitle
			},{
				idColumn: "mes002Pontuacao",
				nameColumn: translate("Pontuação"),
				justify: "left",
				xs: 12,
				sm: 2,
				customHeader: customHeaderColScore
			},{
				idColumn: "",
				nameColumn: "",
				justify: "right",
				cellRenderer: colDelete,
				xs: 12,
				sm: 1
			}]}		
			layout="table"			
		/>
	);

	const strength = metbs002.filter((e) => e.mes002Secao === 0);
	const weaknesses = metbs002.filter((e) => e.mes002Secao === 1);
	const threats = metbs002.filter((e) => e.mes002Secao === 2);
	const opportunities = metbs002.filter((e) => e.mes002Secao === 3);

	return (
		<>
			{strength && strength.length > 0 && (
				<WrapperSwotItems>	
					<TitleSwotItem color="var(--green)">
						{translate("Forças")}
					</TitleSwotItem>
				  {ListComponent(strength)}
				</WrapperSwotItems>
			)}

			{weaknesses && weaknesses.length > 0 && (
				<WrapperSwotItems>	
					<TitleSwotItem color="var(--blue)">
						{translate("Fraquezas")}
					</TitleSwotItem>
					{ListComponent(weaknesses)}
				</WrapperSwotItems>
			)}

			{threats && threats.length > 0 && (
				<WrapperSwotItems>	
					<TitleSwotItem color="var(--yellow)" >
						{translate("Ameaças")}
					</TitleSwotItem>
					{ListComponent(threats)}
				</WrapperSwotItems>
			)}

			{opportunities && opportunities.length > 0 && (
				<WrapperSwotItems>	
					<TitleSwotItem color="var(--red)">
						{translate("Oportunidades")}
					</TitleSwotItem>
					{ListComponent(opportunities)}
				</WrapperSwotItems>
			)}
		
		</>
	);
};

export default SWOTItem;
